/* mitojs/browser version ' + 3.1.21-bate.1 */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var version = "3.1.21-bate.1";
var name$1 = "hltn-mitojs";

var SDK_NAME = name$1 ;
var SDK_VERSION = version ;

var MitoLog = 'Mito.log';
var MitoLogEmptyMsg = 'empty.msg';
var MitoLogEmptyTag = 'empty.tag';
var ERROR_TYPE_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
var globalVar = {
    isLogAddBreadcrumb: true,
    crossOriginThreshold: 1000
};
var Silent = 'silent';

var nativeToString = Object.prototype.toString;
function isType(type) {
    return function (value) {
        return nativeToString.call(value) === "[object ".concat(type, "]");
    };
}
var variableTypeDetection = {
    isNumber: isType("Number"),
    isString: isType("String"),
    isBoolean: isType("Boolean"),
    isNull: isType("Null"),
    isUndefined: isType("Undefined"),
    isSymbol: isType("Symbol"),
    isFunction: isType("Function"),
    isObject: isType("Object"),
    isArray: isType("Array"),
    isProcess: isType("process"),
    isWindow: isType("Window"),
    isNative: isType("Object"),
    isElectronGlobal: isType("global")
};
function isError(wat) {
    switch (nativeToString.call(wat)) {
        case '[object Error]':
            return true;
        case '[object Exception]':
            return true;
        case '[object DOMException]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
function isEmpty(wat) {
    return (variableTypeDetection.isString(wat) && wat.trim() === '') || wat === undefined || wat === null;
}
function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    }
    catch (_e) {
        return false;
    }
}
function isExistProperty(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}

var isNodeEnv = variableTypeDetection.isProcess(typeof process !== 'undefined' ? process : 0);
var isWxMiniEnv = variableTypeDetection.isObject(typeof wx !== 'undefined' ? wx : 0) &&
    variableTypeDetection.isFunction(typeof App !== 'undefined' ? App : 0);
var isBrowserEnv = variableTypeDetection.isWindow(typeof window !== 'undefined' ? window : 0);
var isElectronGlobalEnv = variableTypeDetection.isElectronGlobal(typeof window !== 'undefined' ? window : 0);
var isNative = variableTypeDetection.isNative(typeof window !== 'undefined' ? window : 0);
function getGlobal() {
    if (isBrowserEnv || isElectronGlobalEnv || isNative)
        return window;
    if (isWxMiniEnv)
        return wx;
    if (isNodeEnv)
        return process;
}
var _global = getGlobal();
var _support = getGlobalMitoSupport();
function getGlobalMitoSupport() {
    _global.__MITO__ = _global.__MITO__ || {};
    return _global.__MITO__;
}
function supportsHistory() {
    var chrome = _global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasHistoryApi = 'history' in _global && !!_global.history.pushState && !!_global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

var PREFIX = 'MITO Logger';
var Logger = (function () {
    function Logger() {
        var _this = this;
        this.enabled = false;
        this._console = {};
        _global.console = console || _global.console;
        if (console || _global.console) {
            var logType = ['log', 'debug', 'info', 'warn', 'error', 'assert'];
            logType.forEach(function (level) {
                if (!(level in _global.console))
                    return;
                _this._console[level] = _global.console[level];
            });
        }
    }
    Logger.prototype.disable = function () {
        this.enabled = false;
    };
    Logger.prototype.bindOptions = function (debug) {
        this.enabled = debug ? true : false;
    };
    Logger.prototype.enable = function () {
        this.enabled = true;
    };
    Logger.prototype.getEnableStatus = function () {
        return this.enabled;
    };
    Logger.prototype.log = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this.enabled) {
            return;
        }
        (_a = this._console).log.apply(_a, __spreadArray(["".concat(PREFIX, "[Log]:")], args, false));
    };
    Logger.prototype.warn = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this.enabled) {
            return;
        }
        (_a = this._console).warn.apply(_a, __spreadArray(["".concat(PREFIX, "[Warn]:")], args, false));
    };
    Logger.prototype.error = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        (_a = this._console).error.apply(_a, __spreadArray(["".concat(PREFIX, "[Error]:")], args, false));
    };
    return Logger;
}());
var logger = _support.logger || (_support.logger = new Logger());

function getLocationHref() {
    if (typeof document === 'undefined' || document.location == null)
        return '';
    return document.location.href;
}
function getUrlWithEnv() {
    if (isWxMiniEnv)
        return getCurrentRoute();
    if (isBrowserEnv)
        return getLocationHref();
    return '';
}
function on(target, eventName, handler, opitons) {
    if (opitons === void 0) { opitons = false; }
    target.addEventListener(eventName, handler, opitons);
}
function replaceOld(source, name, replacement, isForced) {
    if (isForced === void 0) { isForced = false; }
    if (source === undefined)
        return;
    if (name in source || isForced) {
        var original = source[name];
        var wrapped = replacement(original);
        if (typeof wrapped === 'function') {
            source[name] = wrapped;
        }
    }
}
var defaultFunctionName = '<anonymous>';
function getFunctionName(fn) {
    if (!fn || typeof fn !== 'function') {
        return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
}
function throttle(fn, delay) {
    var canRun = true;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!canRun)
            return;
        fn.apply(this, args);
        canRun = false;
        setTimeout(function () {
            canRun = true;
        }, delay);
    };
}
function isInclude(origin, target) {
    return !!~origin.indexOf(target);
}
function getTimestamp() {
    return Date.now();
}
function toStringAny(target, type) {
    return nativeToString.call(target) === "[object ".concat(type, "]");
}
function toStringValidateOption(target, targetName, expectType) {
    if (toStringAny(target, expectType))
        return true;
    typeof target !== 'undefined' && logger.error("".concat(targetName, "\u671F\u671B\u4F20\u5165:").concat(expectType, "\u7C7B\u578B\uFF0C\u5F53\u524D\u662F:").concat(nativeToString.call(target), "\u7C7B\u578B"));
    return false;
}
function silentConsoleScope(callback) {
    globalVar.isLogAddBreadcrumb = false;
    callback();
    globalVar.isLogAddBreadcrumb = true;
}
function generateUUID() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
}
function unknownToString(target) {
    if (variableTypeDetection.isString(target)) {
        return target;
    }
    if (variableTypeDetection.isUndefined(target)) {
        return 'undefined';
    }
    return JSON.stringify(target);
}
function setUrlQuery(url, query) {
    var queryArr = [];
    Object.keys(query).forEach(function (k) {
        queryArr.push("".concat(k, "=").concat(query[k]));
    });
    if (url.indexOf('?') !== -1) {
        url = "".concat(url, "&").concat(queryArr.join('&'));
    }
    else {
        url = "".concat(url, "?").concat(queryArr.join('&'));
    }
    return url;
}
function interceptStr(str, interceptLength) {
    if (variableTypeDetection.isString(str)) {
        return str.slice(0, interceptLength) + (str.length > interceptLength ? ";slice the first ".concat(interceptLength, " characters") : '');
    }
    return '';
}
function getCurrentRoute() {
    if (!variableTypeDetection.isFunction(getCurrentPages)) {
        return '';
    }
    var pages = getCurrentPages();
    if (!pages.length) {
        return 'App';
    }
    var currentPage = pages.pop();
    return setUrlQuery(currentPage.route, currentPage.options);
}
function firstStrtoUppercase(str) {
    return str.replace(/\b(\w)(\w*)/g, function ($0, $1, $2) {
        return "".concat($1.toUpperCase()).concat($2);
    });
}
function safeStringify(obj) {
    var set = new Set();
    var str = JSON.stringify(obj, function (_key, value) {
        if (set.has(value)) {
            return 'Circular';
        }
        typeof value === 'object' && set.add(value);
        return value;
    });
    set.clear();
    return str;
}
function validateOptionsAndSet(targetArr) {
    var _this = this;
    targetArr.forEach(function (_a) {
        var target = _a[0], targetName = _a[1], expectType = _a[2];
        return toStringValidateOption(target, targetName, expectType) && (_this[targetName] = target);
    });
}

function htmlElementAsString(target) {
    var tagName = target.tagName.toLowerCase();
    if (tagName === 'body') {
        return null;
    }
    var classNames = target.classList.value;
    classNames = classNames !== '' ? " class=\"".concat(classNames, "\"") : '';
    var id = target.id ? " id=\"".concat(target.id, "\"") : '';
    var innerText = target.innerText;
    return "<".concat(tagName).concat(id).concat(classNames !== '' ? classNames : '', ">").concat(innerText, "</").concat(tagName, ">");
}
function parseUrlToObj(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function getBreadcrumbCategoryInBrowser(type) {
    switch (type) {
        case "Xhr":
        case "Fetch":
            return "http";
        case "UI.Click":
        case "Route":
            return "user";
        case "Customer":
        case "Console":
            return "debug";
        case "Unhandledrejection":
        case "Code Error":
        case "Resource":
        default:
            return "exception";
    }
}
function extractErrorStack(ex, level) {
    var normal = {
        time: getTimestamp(),
        url: getUrlWithEnv(),
        name: ex.name,
        level: level,
        message: ex.message
    };
    if (typeof ex.stack === 'undefined' || !ex.stack) {
        return normal;
    }
    var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[a-z]:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|webpack|resource|\[native).*?|[^@]*bundle)(?::(\d+))?(?::(\d+))?\s*$/i, winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i, geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/, lines = ex.stack.split('\n'), stack = [];
    var submatch, parts, element;
    for (var i = 0, j = lines.length; i < j; ++i) {
        if ((parts = chrome.exec(lines[i]))) {
            var isNative = parts[2] && parts[2].indexOf('native') === 0;
            var isEval = parts[2] && parts[2].indexOf('eval') === 0;
            if (isEval && (submatch = chromeEval.exec(parts[2]))) {
                parts[2] = submatch[1];
                parts[3] = submatch[2];
                parts[4] = submatch[3];
            }
            element = {
                url: !isNative ? parts[2] : null,
                func: parts[1] || "UNKNOWN_FUNCTION",
                args: isNative ? [parts[2]] : [],
                line: parts[3] ? +parts[3] : null,
                column: parts[4] ? +parts[4] : null
            };
        }
        else if ((parts = winjs.exec(lines[i]))) {
            element = {
                url: parts[2],
                func: parts[1] || "UNKNOWN_FUNCTION",
                args: [],
                line: +parts[3],
                column: parts[4] ? +parts[4] : null
            };
        }
        else if ((parts = gecko.exec(lines[i]))) {
            var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
            if (isEval && (submatch = geckoEval.exec(parts[3]))) {
                parts[3] = submatch[1];
                parts[4] = submatch[2];
                parts[5] = null;
            }
            else if (i === 0 && !parts[5] && typeof ex.columnNumber !== 'undefined') {
                stack[0].column = ex.columnNumber + 1;
            }
            element = {
                url: parts[3],
                func: parts[1] || "UNKNOWN_FUNCTION",
                args: parts[2] ? parts[2].split(',') : [],
                line: parts[4] ? +parts[4] : null,
                column: parts[5] ? +parts[5] : null
            };
        }
        else {
            continue;
        }
        if (!element.func && element.line) {
            element.func = "UNKNOWN_FUNCTION";
        }
        stack.push(element);
    }
    if (!stack.length) {
        return null;
    }
    return __assign(__assign({}, normal), { stack: stack });
}

function nativeTryCatch(fn, errorFn) {
    try {
        fn();
    }
    catch (err) {
        console.error('err', err);
        if (errorFn) {
            errorFn(err);
        }
    }
}

var Queue = (function () {
    function Queue() {
        this.stack = [];
        this.isFlushing = false;
        if (!('Promise' in _global))
            return;
        this.micro = Promise.resolve();
    }
    Queue.prototype.addTask = function (fn) {
        var _this = this;
        if (typeof fn !== 'function')
            return;
        if (!('Promise' in _global)) {
            fn();
            return;
        }
        this.stack.push(fn);
        if (!this.isFlushing) {
            this.isFlushing = true;
            this.micro.then(function () { return _this.flushStack(); });
        }
    };
    Queue.prototype.clear = function () {
        this.stack = [];
    };
    Queue.prototype.getStack = function () {
        return this.stack;
    };
    Queue.prototype.flushStack = function () {
        var temp = this.stack.slice(0);
        this.stack.length = 0;
        this.isFlushing = false;
        for (var _i = 0, temp_1 = temp; _i < temp_1.length; _i++) {
            var fn = temp_1[_i];
            fn();
        }
    };
    return Queue;
}());

var Severity;
(function (Severity) {
    Severity["Else"] = "else";
    Severity["Error"] = "error";
    Severity["Warning"] = "warning";
    Severity["Info"] = "info";
    Severity["Debug"] = "debug";
    Severity["Low"] = "low";
    Severity["Normal"] = "normal";
    Severity["High"] = "high";
    Severity["Critical"] = "critical";
})(Severity || (Severity = {}));
(function (Severity) {
    function fromString(level) {
        switch (level) {
            case 'debug':
                return Severity.Debug;
            case 'info':
            case 'log':
            case 'assert':
                return Severity.Info;
            case 'warn':
            case 'warning':
                return Severity.Warning;
            case Severity.Low:
            case Severity.Normal:
            case Severity.High:
            case Severity.Critical:
            case 'error':
                return Severity.Error;
            default:
                return Severity.Else;
        }
    }
    Severity.fromString = fromString;
})(Severity || (Severity = {}));

function fromHttpStatus(httpStatus) {
    if (httpStatus < 400) {
        return "ok";
    }
    if (httpStatus >= 400 && httpStatus < 500) {
        switch (httpStatus) {
            case 401:
                return "unauthenticated";
            case 403:
                return "permission_denied";
            case 404:
                return "not_found";
            case 409:
                return "already_exists";
            case 413:
                return "failed_precondition";
            case 429:
                return "resource_exhausted";
            default:
                return "invalid_argument";
        }
    }
    if (httpStatus >= 500 && httpStatus < 600) {
        switch (httpStatus) {
            case 501:
                return "unimplemented";
            case 503:
                return "unavailable";
            case 504:
                return "deadline_exceeded";
            default:
                return "internal_error";
        }
    }
    return "unknown_error";
}

var allErrorNumber = {};
function createErrorId(data, service, maxDuplicateCount) {
    var id;
    switch (data.type) {
        case "HTTP":
            id = data.type + data.request.method + data.response.status + getRealPath(data.request.url) + service;
            break;
        case "JAVASCRIPT":
        case "VUE":
        case "REACT":
            id = data.type + data.name + data.message + service;
            break;
        case "LOG":
            id = data.customTag + data.type + data.name + service;
            break;
        case "PROMISE":
            id = generatePromiseErrorId(data, service);
            break;
        default:
            id = data.type + data.message + service;
            break;
    }
    id = hashCode(id);
    if (allErrorNumber[id] >= maxDuplicateCount) {
        return null;
    }
    if (typeof allErrorNumber[id] === 'number') {
        allErrorNumber[id]++;
    }
    else {
        allErrorNumber[id] = 1;
    }
    return id;
}
function generatePromiseErrorId(data, service) {
    var locationUrl = getRealPath(data.url);
    if (data.name === "unhandledrejection") {
        return data.type + stringToObjAndOrder(data.message) + service;
    }
    return data.type + data.name + stringToObjAndOrder(data.message) + locationUrl;
}
function sortObjByKey(obj) {
    return Object.keys(obj)
        .sort()
        .reduce(function (total, key) {
        if (variableTypeDetection.isObject(obj[key])) {
            total[key] = sortObjByKey(obj[key]);
        }
        else {
            total[key] = obj[key];
        }
        return total;
    }, {});
}
function stringToObjAndOrder(reason) {
    try {
        if (/\{.*\}/.test(reason)) {
            var obj = JSON.parse(reason);
            obj = sortObjByKey(obj);
            return JSON.stringify(obj);
        }
        return reason;
    }
    catch (error) {
        return reason;
    }
}
function getRealPath(url) {
    return url
        .replace(/[?#].*$/, '')
        .replace(/\/(\d+)\//g, '/{param}/$1')
        .replace(/\/\d+([/]*$)/g, '/{param}$1');
}
function hashCode(str) {
    var hash = 0;
    if (str.length == 0)
        return hash;
    for (var i = 0; i < str.length; i++) {
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
    }
    return hash;
}

function bin2hex(s) {
    var i = 0;
    var o = '';
    var l;
    var n = null;
    s += '';
    for (i = 0, l = s.length; i < l; i++) {
        n = s.charCodeAt(i).toString(16);
        o += n.length < 2 ? '0' + n : n;
    }
    return o;
}
function getFingerprintId(domain) {
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext("2d");
    var txt = domain || 'hltn';
    ctx.textBaseline = "top";
    ctx.font = "14px 'Arial'";
    ctx.fillStyle = "#f60";
    ctx.fillRect(125, 1, 62, 20);
    ctx.fillStyle = "#069";
    ctx.fillText(txt, 2, 15);
    ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
    ctx.fillText(txt, 4, 17);
    var b64 = canvas.toDataURL().replace("data:image/png;base64,", "");
    var bin = atob(b64);
    var crc = bin2hex(bin.slice(-16, -12));
    return crc;
}

var setItem = function (key, data) {
    try {
        if (isWxMiniEnv) {
            wx.setStorageSync(key, data);
        }
        else if (isBrowserEnv || isElectronGlobalEnv) {
            window.localStorage.setItem(key, data);
        }
        else {
            console.warn('current env is not support storage data.');
        }
    }
    catch (err) {
        console.error('storage data exception. err: ', err);
    }
};
var getItem = function (key) {
    try {
        if (isWxMiniEnv) {
            return wx.getStorageSync(key);
        }
        else if (isBrowserEnv || isElectronGlobalEnv) {
            return window.localStorage.getItem(key);
        }
        else {
            console.warn('current env is not support storage data.');
            return null;
        }
    }
    catch (err) {
        console.error('storage data exception. err: ', err);
    }
};
var clear = function () {
    try {
        if (isWxMiniEnv) {
            return wx.clearStorageSync();
        }
        else if (isBrowserEnv || isElectronGlobalEnv) {
            return window.localStorage.clear();
        }
        else {
            console.warn('current env is not support storage data.');
            return null;
        }
    }
    catch (err) {
        console.error('storage data exception. err: ', err);
    }
};
var removeItem = function (key) {
    try {
        if (isWxMiniEnv) {
            return wx.removeStorageSync(key);
        }
        else if (isBrowserEnv || isElectronGlobalEnv) {
            return window.localStorage.removeItem(key);
        }
        else {
            console.warn('current env is not support storage data.');
            return null;
        }
    }
    catch (err) {
        console.error('storage data exception. err: ', err);
    }
};
var storage = {
    get: function (key) {
        var result = getItem(key);
        try {
            return JSON.parse(result);
        }
        catch (err) {
            console.error(err);
            return '';
        }
    },
    set: function (key, data) {
        try {
            setItem(key, JSON.stringify(data));
        }
        catch (err) {
            console.error(err);
        }
    },
    remove: function (key) {
        removeItem(key);
    },
    clear: function () {
        clear();
    }
};
var STORAGE_PAGEID = 'mito_pageId';
var STORAGE_PREVPAGEID = 'mito_prevPageId';

var Breadcrumb = (function () {
    function Breadcrumb(options) {
        if (options === void 0) { options = {}; }
        this.maxBreadcrumbs = 10;
        this.beforePushBreadcrumb = null;
        this.stack = [];
        this.notTransferResponse = true;
        this.bindOptions(options);
    }
    Breadcrumb.prototype.push = function (data) {
        var _this = this;
        var _a;
        if (typeof this.beforePushBreadcrumb === 'function') {
            var result_1 = null;
            var beforePushBreadcrumb_1 = this.beforePushBreadcrumb;
            silentConsoleScope(function () {
                result_1 = beforePushBreadcrumb_1.call(_this, _this, data);
            });
            if (!result_1)
                return this.stack;
            return this.immediatePush(result_1);
        }
        if (this.notTransferResponse && ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.response)) {
            delete data.data.response.data;
        }
        return this.immediatePush(data);
    };
    Breadcrumb.prototype.immediatePush = function (data) {
        data.time || (data.time = getTimestamp());
        if (this.stack.length >= this.maxBreadcrumbs) {
            this.shift();
        }
        this.stack.push(data);
        this.stack.sort(function (a, b) { return a.time - b.time; });
        logger.log(this.stack);
        return this.stack;
    };
    Breadcrumb.prototype.shift = function () {
        return this.stack.shift() !== undefined;
    };
    Breadcrumb.prototype.clear = function () {
        this.stack = [];
    };
    Breadcrumb.prototype.getStack = function () {
        return this.stack;
    };
    Breadcrumb.prototype.bindOptions = function (options) {
        if (options === void 0) { options = {}; }
        var maxBreadcrumbs = options.maxBreadcrumbs, beforePushBreadcrumb = options.beforePushBreadcrumb, notTransferResponse = options.notTransferResponse;
        toStringValidateOption(notTransferResponse, 'notTransferResponse', "Boolean") && (this.notTransferResponse = notTransferResponse);
        toStringValidateOption(maxBreadcrumbs, 'maxBreadcrumbs', "Number") && (this.maxBreadcrumbs = maxBreadcrumbs);
        toStringValidateOption(beforePushBreadcrumb, 'beforePushBreadcrumb', "Function") &&
            (this.beforePushBreadcrumb = beforePushBreadcrumb);
    };
    return Breadcrumb;
}());

var Subscribe = (function () {
    function Subscribe() {
        this.dep = new Map();
    }
    Subscribe.prototype.watch = function (eventName, callBack) {
        var fns = this.dep.get(eventName);
        if (fns) {
            this.dep.set(eventName, fns.concat(callBack));
            return;
        }
        this.dep.set(eventName, [callBack]);
    };
    Subscribe.prototype.notify = function (eventName, data) {
        var fns = this.dep.get(eventName);
        if (!eventName || !fns)
            return;
        fns.forEach(function (fn) {
            nativeTryCatch(function () {
                fn(data);
            }, function (e) {
                logger.error("Subscribe.notify\uFF1A\u76D1\u542C\u4E8B\u4EF6\u7684\u56DE\u8C03\u51FD\u6570\u53D1\u751F\u9519\u8BEF\neventName:".concat(eventName, "\nName: ").concat(getFunctionName(fn), "\nError: ").concat(e));
            });
        });
    };
    return Subscribe;
}());

var BaseClient = (function () {
    function BaseClient(options) {
        this.SDK_VERSION = SDK_VERSION;
        this.options = options;
        logger.bindOptions(options.debug);
    }
    BaseClient.prototype.use = function (plugins) {
        var _this = this;
        if (this.options.disabled) {
            console.info('[mito]sdk not init. disabled: ', this.options.disabled);
            return;
        }
        var subscribe = new Subscribe();
        plugins.forEach(function (item) {
            if (!_this.isPluginEnable(item.name))
                return;
            item.monitor.call(_this, subscribe.notify.bind(subscribe));
            var wrapperTransform = function () {
                var _a, _b;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var res = (_a = item.transform) === null || _a === void 0 ? void 0 : _a.apply(_this, args);
                (_b = item.consumer) === null || _b === void 0 ? void 0 : _b.call(_this, res);
            };
            subscribe.watch(item.name, wrapperTransform);
        });
    };
    BaseClient.prototype.getOptions = function () {
        return this.options;
    };
    return BaseClient;
}());

var BaseOptions = (function () {
    function BaseOptions() {
        this.enableTraceId = false;
        this.swTraceId = true;
        this.webPerformance = true;
        this.includeHttpUrlTraceIdRegExp = /.*/;
        this.traceIdFieldName = 'Trace-Id';
        this.throttleDelayTime = 0;
        this.beforeAppAjaxSend = null;
        this.vue = null;
    }
    BaseOptions.prototype.bindOptions = function (options) {
        var enableTraceId = options.enableTraceId, vue = options.vue, filterXhrUrlRegExp = options.filterXhrUrlRegExp, traceIdFieldName = options.traceIdFieldName, throttleDelayTime = options.throttleDelayTime, includeHttpUrlTraceIdRegExp = options.includeHttpUrlTraceIdRegExp, beforeAppAjaxSend = options.beforeAppAjaxSend, swTraceId = options.swTraceId, webPerformance = options.webPerformance;
        var optionArr = [
            [enableTraceId, 'enableTraceId', "Boolean"],
            [swTraceId, 'swTraceId', "Boolean"],
            [webPerformance, 'webPerformance', "Boolean"],
            [traceIdFieldName, 'traceIdFieldName', "String"],
            [throttleDelayTime, 'throttleDelayTime', "Number"],
            [filterXhrUrlRegExp, 'filterXhrUrlRegExp', "RegExp"],
            [includeHttpUrlTraceIdRegExp, 'includeHttpUrlTraceIdRegExp', "RegExp"],
            [beforeAppAjaxSend, 'beforeAppAjaxSend', "Function"]
        ];
        validateOptionsAndSet.call(this, optionArr);
        this.vue = vue;
    };
    BaseOptions.prototype.isFilterHttpUrl = function (url) {
        return this.filterXhrUrlRegExp && this.filterXhrUrlRegExp.test(url);
    };
    BaseOptions.prototype.setTraceId = function (httpUrl, callback) {
        var _a = this, includeHttpUrlTraceIdRegExp = _a.includeHttpUrlTraceIdRegExp, enableTraceId = _a.enableTraceId;
        if (enableTraceId && includeHttpUrlTraceIdRegExp && includeHttpUrlTraceIdRegExp.test(httpUrl)) {
            var traceId = generateUUID();
            callback(this.traceIdFieldName, traceId);
        }
    };
    return BaseOptions;
}());

var HltnSubjectType;
(function (HltnSubjectType) {
    HltnSubjectType["hll"] = "hualala";
    HltnSubjectType["wandou"] = "wandou";
    HltnSubjectType["gubi"] = "gubi";
    HltnSubjectType["mmears"] = "mmears";
    HltnSubjectType["other"] = "other";
    HltnSubjectType["wandou_yizhi"] = "wandou_yizhi";
    HltnSubjectType["wandou_koucai"] = "wandou_koucai";
    HltnSubjectType["wandou_program"] = "wandou_program";
    HltnSubjectType["wandou_go"] = "wandou_go";
    HltnSubjectType["gubi_go"] = "gubi_go";
    HltnSubjectType["gubi_art"] = "gubi_art";
    HltnSubjectType["gubi_music"] = "gubi_music";
    HltnSubjectType["xiaodengta"] = "xiaodengta";
})(HltnSubjectType || (HltnSubjectType = {}));
var HltnBizType;
(function (HltnBizType) {
    HltnBizType["maliang"] = "maliang";
    HltnBizType["course"] = "course";
    HltnBizType["pay"] = "pay";
    HltnBizType["report"] = "report";
    HltnBizType["referral"] = "referral";
    HltnBizType["activity"] = "activity";
    HltnBizType["cc"] = "cc";
    HltnBizType["lp"] = "lp";
    HltnBizType["sh_lp"] = "sh_lp";
    HltnBizType["sh_cc"] = "sh_cc";
    HltnBizType["workbranch"] = "workbranch";
    HltnBizType["work_weixin"] = "work_weixin";
    HltnBizType["crm"] = "crm";
    HltnBizType["cms"] = "cms";
    HltnBizType["customer"] = "customer";
    HltnBizType["wdmama"] = "wdmama";
    HltnBizType["league"] = "league";
    HltnBizType["other"] = "other";
})(HltnBizType || (HltnBizType = {}));
var HltnAppNameType;
(function (HltnAppNameType) {
    HltnAppNameType["weixin"] = "weixin";
    HltnAppNameType["alipay"] = "alipay";
    HltnAppNameType["douyin"] = "douyin";
    HltnAppNameType["hualala_pc"] = "hualala_pc";
    HltnAppNameType["hualala_app"] = "hualala_app";
    HltnAppNameType["gubi_app"] = "gubi_app";
    HltnAppNameType["wandou_student"] = "wandou_student";
    HltnAppNameType["wandou_student_pc"] = "wandou_student_pc";
    HltnAppNameType["wandou_parent"] = "wandou_parent";
    HltnAppNameType["wandou_teacher"] = "wandou_teacher";
    HltnAppNameType["wandou_teacher_pc"] = "wandou_teacher_pc";
    HltnAppNameType["wonderclass"] = "wonderclass";
    HltnAppNameType["xiaodengta"] = "xiaodengta";
    HltnAppNameType["mmears_app"] = "mmears_app";
    HltnAppNameType["browser"] = "browser";
    HltnAppNameType["other"] = "other";
})(HltnAppNameType || (HltnAppNameType = {}));
var BizInfoDefaultProperty = [
    'appVersion',
    'appName',
    'pageTitle',
    'sensorId',
    'bizType',
    'subject'
];

var BizInfo = (function () {
    function BizInfo(options) {
        if (options === void 0) { options = {}; }
        this.bindOptions(options);
    }
    BizInfo.prototype.bindOptions = function (options) {
        var _this = this;
        var _a = options.appVersion, appVersion = _a === void 0 ? '' : _a, _b = options.appName, appName = _b === void 0 ? '' : _b, _c = options.pageTitle, pageTitle = _c === void 0 ? '' : _c, _d = options.sensorId, sensorId = _d === void 0 ? '' : _d, _e = options.bizType, bizType = _e === void 0 ? '' : _e, _f = options.subject, subject = _f === void 0 ? '' : _f;
        var optionArr = [
            [appVersion, 'appVersion', "String"],
            [appName, 'appName', "String"],
            [pageTitle, 'pageTitle', "String"],
            [sensorId, 'sensorId', "String"],
            [bizType, 'bizType', "String"],
            [subject, 'subject', "String"]
        ];
        validateOptionsAndSet.call(this, optionArr);
        Object.keys(options).forEach(function (key) {
            if (!BizInfoDefaultProperty.includes(key)) {
                _this[key] = options[key];
            }
        });
    };
    BizInfo.prototype.toJSON = function () {
        var _this = this;
        var _bizInfo = {};
        Object.keys(this).forEach(function (key) {
            _bizInfo[key] = _this[key];
        });
        return _bizInfo;
    };
    return BizInfo;
}());

var getUUID = function () {
    var timestamp = new Date().getTime();
    var perforNow = (typeof performance !== 'undefined' && performance.now && performance.now() * 1000) || 0;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var random = Math.random() * 16;
        if (timestamp > 0) {
            random = (timestamp + random) % 16 | 0;
            timestamp = Math.floor(timestamp / 16);
        }
        else {
            random = (perforNow + random) % 16 | 0;
            perforNow = Math.floor(perforNow / 16);
        }
        return (c === 'x' ? random : (random & 0x3) | 0x8).toString(16);
    });
};

function initPageId() {
    var _pageId = storage.get(STORAGE_PAGEID);
    storage.remove(STORAGE_PAGEID);
    storage.remove(STORAGE_PREVPAGEID);
    var pageId = '';
    var prevPageId = '';
    if ((!_pageId && !prevPageId) || !_pageId) {
        pageId = getUUID();
        storage.set(STORAGE_PAGEID, pageId);
        storage.set(STORAGE_PREVPAGEID, prevPageId);
        return { pageId: pageId, prevPageId: prevPageId };
    }
    if (_pageId) {
        pageId = getUUID();
        prevPageId = _pageId;
        storage.set(STORAGE_PAGEID, pageId);
        storage.set(STORAGE_PREVPAGEID, _pageId);
        return { pageId: pageId, prevPageId: prevPageId };
    }
    return { pageId: pageId, prevPageId: prevPageId };
}

var BaseTransport = (function () {
    function BaseTransport() {
        this.dsn = '';
        this.service = '';
        this.beforeDataReport = null;
        this.backTrackerId = null;
        this.configReportUrl = null;
        this.maxDuplicateCount = 3;
        this.pageId = '';
        this.userId = '';
        this.queue = new Queue();
        this.pageId = initPageId().pageId;
        this.bizInfo = new BizInfo();
    }
    BaseTransport.prototype.getAuthInfo = function () {
        var trackerId = this.getTrackerId();
        var result = {
            trackerId: String(trackerId),
            sdkVersion: SDK_VERSION,
            sdkName: SDK_NAME,
            service: this.service,
            pageId: this.pageId,
            prevPageId: storage.get(STORAGE_PREVPAGEID),
            userId: this.userId,
            userAgent: navigator && navigator.userAgent || ''
        };
        return result;
    };
    BaseTransport.prototype.getTrackerId = function () {
        if (isWxMiniEnv) {
            logger.log('env: wx-mini: ', isWxMiniEnv);
            return '';
        }
        var trackerId = getFingerprintId();
        if (typeof trackerId === 'string') {
            return trackerId;
        }
        else {
            logger.error("trackerId:".concat(trackerId, " \u671F\u671B string \u7C7B\u578B\uFF0C\u4F46\u662F\u4F20\u5165 ").concat(typeof trackerId));
            return '';
        }
    };
    BaseTransport.prototype.isSelfDsn = function (targetUrl) {
        return this.dsn && isInclude(targetUrl, this.dsn);
    };
    BaseTransport.prototype.bindOptions = function (options) {
        if (options === void 0) { options = {}; }
        var dsn = options.dsn, beforeDataReport = options.beforeDataReport, service = options.service, maxDuplicateCount = options.maxDuplicateCount, backTrackerId = options.backTrackerId, configReportUrl = options.configReportUrl;
        var functionType = "Function";
        var optionArr = [
            [service, 'service', "String"],
            [dsn, 'dsn', "String"],
            [maxDuplicateCount, 'maxDuplicateCount', "Number"],
            [beforeDataReport, 'beforeDataReport', functionType],
            [backTrackerId, 'backTrackerId', functionType],
            [configReportUrl, 'configReportUrl', functionType]
        ];
        validateOptionsAndSet.call(this, optionArr);
    };
    BaseTransport.prototype.send = function (data, breadcrumb) {
        if (breadcrumb === void 0) { breadcrumb = []; }
        return __awaiter(this, void 0, void 0, function () {
            var errorId, transportData, dsn;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!data.isTrack) {
                            errorId = createErrorId(data, this.service, this.maxDuplicateCount);
                            if (!errorId)
                                return [2];
                            data.errorId = errorId;
                        }
                        transportData = __assign(__assign({}, this.getTransportData(data)), { breadcrumb: breadcrumb, bizInfo: this.bizInfo });
                        if (!(typeof this.beforeDataReport === 'function')) return [3, 2];
                        return [4, this.beforeDataReport(transportData)];
                    case 1:
                        transportData = _a.sent();
                        if (!transportData)
                            return [2];
                        _a.label = 2;
                    case 2:
                        dsn = this.dsn;
                        if (isEmpty(dsn)) {
                            logger.error('dsn is empty,pass in when initializing please');
                            return [2];
                        }
                        if (typeof this.configReportUrl === 'function') {
                            dsn = this.configReportUrl(transportData, dsn);
                            if (!dsn)
                                return [2];
                        }
                        return [2, this.sendToServer(transportData, dsn)];
                }
            });
        });
    };
    BaseTransport.prototype.setBizInfo = function (data) {
        this.bizInfo && this.bizInfo.bindOptions && this.bizInfo.bindOptions(__assign(__assign({}, this.bizInfo), data));
    };
    BaseTransport.prototype.ping = function (data, breadcrumb) {
        if (breadcrumb === void 0) { breadcrumb = []; }
        return __awaiter(this, void 0, void 0, function () {
            var errorId, transportData, dsn;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!data.isTrack) {
                            errorId = createErrorId(data, this.service, this.maxDuplicateCount);
                            if (!errorId)
                                return [2];
                            data.errorId = errorId;
                        }
                        transportData = __assign(__assign({}, this.getTransportData(data)), { breadcrumb: breadcrumb, bizInfo: this.bizInfo });
                        if (!(typeof this.beforeDataReport === 'function')) return [3, 2];
                        return [4, this.beforeDataReport(transportData)];
                    case 1:
                        transportData = _a.sent();
                        if (!transportData)
                            return [2];
                        _a.label = 2;
                    case 2:
                        dsn = this.dsn;
                        if (isEmpty(dsn)) {
                            logger.error('dsn is empty,pass in when initializing please');
                            return [2];
                        }
                        if (typeof this.configReportUrl === 'function') {
                            dsn = this.configReportUrl(transportData, dsn);
                            if (!dsn)
                                return [2];
                        }
                        return [2, this.sendBeacon(transportData, dsn)];
                }
            });
        });
    };
    return BaseTransport;
}());

var BrowserOptions = (function (_super) {
    __extends(BrowserOptions, _super);
    function BrowserOptions(options) {
        var _this = _super.call(this) || this;
        _this.configReportXhr = null;
        _super.prototype.bindOptions.call(_this, options);
        _this.bindOptions(options);
        return _this;
    }
    BrowserOptions.prototype.bindOptions = function (options) {
        var silentXhr = options.silentXhr, silentFetch = options.silentFetch, silentConsole = options.silentConsole, silentDom = options.silentDom, silentHistory = options.silentHistory, silentError = options.silentError, silentHashchange = options.silentHashchange, silentUnhandledrejection = options.silentUnhandledrejection, useImgUpload = options.useImgUpload, swTraceId = options.swTraceId, webPerformance = options.webPerformance, configReportXhr = options.configReportXhr;
        var booleanType = "Boolean";
        var optionArr = [
            [silentXhr, 'silentXhr', booleanType],
            [silentFetch, 'silentFetch', booleanType],
            [silentConsole, 'silentConsole', booleanType],
            [silentDom, 'silentDom', booleanType],
            [silentHistory, 'silentHistory', booleanType],
            [silentError, 'silentError', booleanType],
            [silentHashchange, 'silentHashchange', booleanType],
            [silentUnhandledrejection, 'silentUnhandledrejection', booleanType],
            [useImgUpload, 'useImgUpload', booleanType],
            [swTraceId, 'swTraceId', "Boolean"],
            [webPerformance, 'webPerformance', "Boolean"],
            [configReportXhr, 'configReportXhr', "Function"],
        ];
        validateOptionsAndSet.call(this, optionArr);
    };
    return BrowserOptions;
}(BaseOptions));

var BrowserTransport = (function (_super) {
    __extends(BrowserTransport, _super);
    function BrowserTransport(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this) || this;
        _this.useImgUpload = false;
        _super.prototype.bindOptions.call(_this, options);
        _this.bindOptions(options);
        if (!_this.bizInfo) {
            _this.bizInfo = new BizInfo();
        }
        !!options.bizInfo && _this.bizInfo.bindOptions(options.bizInfo);
        return _this;
    }
    BrowserTransport.prototype.post = function (data, url) {
        var _this = this;
        var requestFun = function () {
            var xhr = new XMLHttpRequest();
            xhr.open("POST", url);
            xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
            xhr.withCredentials = true;
            if (typeof _this.configReportXhr === 'function') {
                _this.configReportXhr(xhr, data);
            }
            xhr.send(safeStringify(data));
        };
        this.queue.addTask(requestFun);
    };
    BrowserTransport.prototype.imgRequest = function (data, url) {
        var requestFun = function () {
            var img = new Image();
            var spliceStr = url.indexOf('?') === -1 ? '?' : '&';
            img.src = "".concat(url).concat(spliceStr, "data=").concat(encodeURIComponent(safeStringify(data)));
            img = null;
        };
        this.queue.addTask(requestFun);
    };
    BrowserTransport.prototype.sendBeacon = function (data, url) {
        var requestFun = function () { return navigator && navigator.sendBeacon && navigator.sendBeacon(url, JSON.stringify(data)); };
        this.queue.addTask(requestFun);
    };
    BrowserTransport.prototype.sendToServer = function (data, url) {
        return this.useImgUpload ? this.imgRequest(data, url) : this.post(data, url);
    };
    BrowserTransport.prototype.getTransportData = function (data) {
        return {
            authInfo: this.getAuthInfo(),
            data: data
        };
    };
    BrowserTransport.prototype.bindOptions = function (options) {
        if (options === void 0) { options = {}; }
        var configReportXhr = options.configReportXhr, useImgUpload = options.useImgUpload;
        toStringValidateOption(configReportXhr, 'configReportXhr', "Function") && (this.configReportXhr = configReportXhr);
        toStringValidateOption(useImgUpload, 'useImgUpload', "Boolean") && (this.useImgUpload = useImgUpload);
    };
    return BrowserTransport;
}(BaseTransport));

var bfcacheRestoreTime = -1;
var getBFCacheRestoreTime = function () { return bfcacheRestoreTime; };
var onBFCacheRestore = function (cb) {
    addEventListener('pageshow', function (event) {
        if (event.persisted) {
            bfcacheRestoreTime = event.timeStamp;
            cb(event);
        }
    }, true);
};

var generateUniqueID = function () {
    return "v3-".concat(Date.now(), "-").concat(Math.floor(Math.random() * (9e12 - 1)) + 1e12);
};

var getNavigationEntryFromPerformanceTiming = function () {
    var timing = performance.timing;
    var type = performance.navigation.type;
    var navigationEntry = {
        entryType: 'navigation',
        startTime: 0,
        type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate',
    };
    for (var key in timing) {
        if (key !== 'navigationStart' && key !== 'toJSON') {
            navigationEntry[key] = Math.max(timing[key] -
                timing.navigationStart, 0);
        }
    }
    return navigationEntry;
};
var getNavigationEntry = function () {
    if (window.__WEB_VITALS_POLYFILL__) {
        return (window.performance &&
            ((performance.getEntriesByType &&
                performance.getEntriesByType('navigation')[0]) ||
                getNavigationEntryFromPerformanceTiming()));
    }
    else {
        return (window.performance &&
            performance.getEntriesByType &&
            performance.getEntriesByType('navigation')[0]);
    }
};

var getActivationStart = function () {
    var navEntry = getNavigationEntry();
    return (navEntry && navEntry.activationStart) || 0;
};

var initMetric = function (name, value) {
    var navEntry = getNavigationEntry();
    var navigationType = 'navigate';
    if (getBFCacheRestoreTime() >= 0) {
        navigationType = 'back-forward-cache';
    }
    else if (navEntry) {
        if (document.prerendering || getActivationStart() > 0) {
            navigationType = 'prerender';
        }
        else if (document.wasDiscarded) {
            navigationType = 'restore';
        }
        else if (navEntry.type) {
            navigationType = navEntry.type.replace(/_/g, '-');
        }
    }
    var entries = [];
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: entries,
        id: generateUniqueID(),
        navigationType: navigationType,
    };
};

var observe = function (type, callback, opts) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            var po = new PerformanceObserver(function (list) {
                Promise.resolve().then(function () {
                    callback(list.getEntries());
                });
            });
            po.observe(Object.assign({
                type: type,
                buffered: true,
            }, opts || {}));
            return po;
        }
    }
    catch (e) {
    }
    return;
};

var getRating = function (value, thresholds) {
    if (value > thresholds[1]) {
        return 'poor';
    }
    if (value > thresholds[0]) {
        return 'needs-improvement';
    }
    return 'good';
};
var bindReporter = function (callback, metric, thresholds, reportAllChanges) {
    var prevValue;
    var delta;
    return function (forceReport) {
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};

var doubleRAF = function (cb) {
    requestAnimationFrame(function () { return requestAnimationFrame(function () { return cb(); }); });
};

var onHidden = function (cb) {
    var onHiddenOrPageHide = function (event) {
        if (event.type === 'pagehide' || document.visibilityState === 'hidden') {
            cb(event);
        }
    };
    addEventListener('visibilitychange', onHiddenOrPageHide, true);
    addEventListener('pagehide', onHiddenOrPageHide, true);
};

var runOnce = function (cb) {
    var called = false;
    return function (arg) {
        if (!called) {
            cb(arg);
            called = true;
        }
    };
};

var firstHiddenTime = -1;
var initHiddenTime = function () {
    return document.visibilityState === 'hidden' && !document.prerendering
        ? 0
        : Infinity;
};
var onVisibilityUpdate = function (event) {
    if (document.visibilityState === 'hidden' && firstHiddenTime > -1) {
        firstHiddenTime = event.type === 'visibilitychange' ? event.timeStamp : 0;
        removeChangeListeners();
    }
};
var addChangeListeners = function () {
    addEventListener('visibilitychange', onVisibilityUpdate, true);
    addEventListener('prerenderingchange', onVisibilityUpdate, true);
};
var removeChangeListeners = function () {
    removeEventListener('visibilitychange', onVisibilityUpdate, true);
    removeEventListener('prerenderingchange', onVisibilityUpdate, true);
};
var getVisibilityWatcher = function () {
    if (firstHiddenTime < 0) {
        if (window.__WEB_VITALS_POLYFILL__) {
            firstHiddenTime = window.webVitals.firstHiddenTime;
            if (firstHiddenTime === Infinity) {
                addChangeListeners();
            }
        }
        else {
            firstHiddenTime = initHiddenTime();
            addChangeListeners();
        }
        onBFCacheRestore(function () {
            setTimeout(function () {
                firstHiddenTime = initHiddenTime();
                addChangeListeners();
            }, 0);
        });
    }
    return {
        get firstHiddenTime() {
            return firstHiddenTime;
        },
    };
};

var whenActivated = function (callback) {
    if (document.prerendering) {
        addEventListener('prerenderingchange', function () { return callback(); }, true);
    }
    else {
        callback();
    }
};

var FCPThresholds = [1800, 3000];
var onFCP = function (onReport, opts) {
    opts = opts || {};
    whenActivated(function () {
        var visibilityWatcher = getVisibilityWatcher();
        var metric = initMetric('FCP');
        var report;
        var handleEntries = function (entries) {
            entries.forEach(function (entry) {
                if (entry.name === 'first-contentful-paint') {
                    po.disconnect();
                    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                        metric.value = Math.max(entry.startTime - getActivationStart(), 0);
                        metric.entries.push(entry);
                        report(true);
                    }
                }
            });
        };
        var po = observe('paint', handleEntries);
        if (po) {
            report = bindReporter(onReport, metric, FCPThresholds, opts.reportAllChanges);
            onBFCacheRestore(function (event) {
                metric = initMetric('FCP');
                report = bindReporter(onReport, metric, FCPThresholds, opts.reportAllChanges);
                doubleRAF(function () {
                    metric.value = performance.now() - event.timeStamp;
                    report(true);
                });
            });
        }
    });
};

var CLSThresholds = [0.1, 0.25];
var onCLS = function (onReport, opts) {
    opts = opts || {};
    onFCP(runOnce(function () {
        var metric = initMetric('CLS', 0);
        var report;
        var sessionValue = 0;
        var sessionEntries = [];
        var handleEntries = function (entries) {
            entries.forEach(function (entry) {
                if (!entry.hadRecentInput) {
                    var firstSessionEntry = sessionEntries[0];
                    var lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                    if (sessionValue &&
                        entry.startTime - lastSessionEntry.startTime < 1000 &&
                        entry.startTime - firstSessionEntry.startTime < 5000) {
                        sessionValue += entry.value;
                        sessionEntries.push(entry);
                    }
                    else {
                        sessionValue = entry.value;
                        sessionEntries = [entry];
                    }
                }
            });
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                report();
            }
        };
        var po = observe('layout-shift', handleEntries);
        if (po) {
            report = bindReporter(onReport, metric, CLSThresholds, opts.reportAllChanges);
            onHidden(function () {
                handleEntries(po.takeRecords());
                report(true);
            });
            onBFCacheRestore(function () {
                sessionValue = 0;
                metric = initMetric('CLS', 0);
                report = bindReporter(onReport, metric, CLSThresholds, opts.reportAllChanges);
                doubleRAF(function () { return report(); });
            });
            setTimeout(report, 0);
        }
    }));
};

var firstInputEvent;
var firstInputDelay;
var firstInputTimeStamp;
var callbacks;
var listenerOpts = { passive: true, capture: true };
var startTimeStamp = new Date();
var firstInputPolyfill = function (onFirstInput) {
    callbacks.push(onFirstInput);
    reportFirstInputDelayIfRecordedAndValid();
};
var resetFirstInputPolyfill = function () {
    callbacks = [];
    firstInputDelay = -1;
    firstInputEvent = null;
    eachEventType(addEventListener);
};
var recordFirstInputDelay = function (delay, event) {
    if (!firstInputEvent) {
        firstInputEvent = event;
        firstInputDelay = delay;
        firstInputTimeStamp = new Date();
        eachEventType(removeEventListener);
        reportFirstInputDelayIfRecordedAndValid();
    }
};
var reportFirstInputDelayIfRecordedAndValid = function () {
    if (firstInputDelay >= 0 &&
        firstInputDelay < firstInputTimeStamp - startTimeStamp) {
        var entry_1 = {
            entryType: 'first-input',
            name: firstInputEvent.type,
            target: firstInputEvent.target,
            cancelable: firstInputEvent.cancelable,
            startTime: firstInputEvent.timeStamp,
            processingStart: firstInputEvent.timeStamp + firstInputDelay,
        };
        callbacks.forEach(function (callback) {
            callback(entry_1);
        });
        callbacks = [];
    }
};
var onPointerDown = function (delay, event) {
    var onPointerUp = function () {
        recordFirstInputDelay(delay, event);
        removePointerEventListeners();
    };
    var onPointerCancel = function () {
        removePointerEventListeners();
    };
    var removePointerEventListeners = function () {
        removeEventListener('pointerup', onPointerUp, listenerOpts);
        removeEventListener('pointercancel', onPointerCancel, listenerOpts);
    };
    addEventListener('pointerup', onPointerUp, listenerOpts);
    addEventListener('pointercancel', onPointerCancel, listenerOpts);
};
var onInput = function (event) {
    if (event.cancelable) {
        var isEpochTime = event.timeStamp > 1e12;
        var now = isEpochTime ? new Date() : performance.now();
        var delay = now - event.timeStamp;
        if (event.type == 'pointerdown') {
            onPointerDown(delay, event);
        }
        else {
            recordFirstInputDelay(delay, event);
        }
    }
};
var eachEventType = function (callback) {
    var eventTypes = ['mousedown', 'keydown', 'touchstart', 'pointerdown'];
    eventTypes.forEach(function (type) { return callback(type, onInput, listenerOpts); });
};

var FIDThresholds = [100, 300];
var onFID = function (onReport, opts) {
    opts = opts || {};
    whenActivated(function () {
        var visibilityWatcher = getVisibilityWatcher();
        var metric = initMetric('FID');
        var report;
        var handleEntry = function (entry) {
            if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                metric.value = entry.processingStart - entry.startTime;
                metric.entries.push(entry);
                report(true);
            }
        };
        var handleEntries = function (entries) {
            entries.forEach(handleEntry);
        };
        var po = observe('first-input', handleEntries);
        report = bindReporter(onReport, metric, FIDThresholds, opts.reportAllChanges);
        if (po) {
            onHidden(runOnce(function () {
                handleEntries(po.takeRecords());
                po.disconnect();
            }));
        }
        if (window.__WEB_VITALS_POLYFILL__) {
            console.warn('The web-vitals "base+polyfill" build is deprecated. See: https://bit.ly/3aqzsGm');
            if (!po) {
                window.webVitals.firstInputPolyfill(handleEntry);
            }
            onBFCacheRestore(function () {
                metric = initMetric('FID');
                report = bindReporter(onReport, metric, FIDThresholds, opts.reportAllChanges);
                window.webVitals.resetFirstInputPolyfill();
                window.webVitals.firstInputPolyfill(handleEntry);
            });
        }
        else {
            if (po) {
                onBFCacheRestore(function () {
                    metric = initMetric('FID');
                    report = bindReporter(onReport, metric, FIDThresholds, opts.reportAllChanges);
                    resetFirstInputPolyfill();
                    firstInputPolyfill(handleEntry);
                });
            }
        }
    });
};

var interactionCountEstimate = 0;
var minKnownInteractionId = Infinity;
var maxKnownInteractionId = 0;
var updateEstimate = function (entries) {
    entries.forEach(function (e) {
        if (e.interactionId) {
            minKnownInteractionId = Math.min(minKnownInteractionId, e.interactionId);
            maxKnownInteractionId = Math.max(maxKnownInteractionId, e.interactionId);
            interactionCountEstimate = maxKnownInteractionId
                ? (maxKnownInteractionId - minKnownInteractionId) / 7 + 1
                : 0;
        }
    });
};
var po;
var getInteractionCount = function () {
    return po ? interactionCountEstimate : performance.interactionCount || 0;
};
var initInteractionCountPolyfill = function () {
    if ('interactionCount' in performance || po)
        return;
    po = observe('event', updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0,
    });
};

var INPThresholds = [200, 500];
var prevInteractionCount = 0;
var getInteractionCountForNavigation = function () {
    return getInteractionCount() - prevInteractionCount;
};
var MAX_INTERACTIONS_TO_CONSIDER = 10;
var longestInteractionList = [];
var longestInteractionMap = {};
var processEntry = function (entry) {
    var minLongestInteraction = longestInteractionList[longestInteractionList.length - 1];
    var existingInteraction = longestInteractionMap[entry.interactionId];
    if (existingInteraction ||
        longestInteractionList.length < MAX_INTERACTIONS_TO_CONSIDER ||
        entry.duration > minLongestInteraction.latency) {
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        }
        else {
            var interaction = {
                id: entry.interactionId,
                latency: entry.duration,
                entries: [entry],
            };
            longestInteractionMap[interaction.id] = interaction;
            longestInteractionList.push(interaction);
        }
        longestInteractionList.sort(function (a, b) { return b.latency - a.latency; });
        longestInteractionList.splice(MAX_INTERACTIONS_TO_CONSIDER).forEach(function (i) {
            delete longestInteractionMap[i.id];
        });
    }
};
var estimateP98LongestInteraction = function () {
    var candidateInteractionIndex = Math.min(longestInteractionList.length - 1, Math.floor(getInteractionCountForNavigation() / 50));
    return longestInteractionList[candidateInteractionIndex];
};
var onINP = function (onReport, opts) {
    opts = opts || {};
    whenActivated(function () {
        initInteractionCountPolyfill();
        var metric = initMetric('INP');
        var report;
        var handleEntries = function (entries) {
            entries.forEach(function (entry) {
                if (entry.interactionId) {
                    processEntry(entry);
                }
                if (entry.entryType === 'first-input') {
                    var noMatchingEntry = !longestInteractionList.some(function (interaction) {
                        return interaction.entries.some(function (prevEntry) {
                            return (entry.duration === prevEntry.duration &&
                                entry.startTime === prevEntry.startTime);
                        });
                    });
                    if (noMatchingEntry) {
                        processEntry(entry);
                    }
                }
            });
            var inp = estimateP98LongestInteraction();
            if (inp && inp.latency !== metric.value) {
                metric.value = inp.latency;
                metric.entries = inp.entries;
                report();
            }
        };
        var po = observe('event', handleEntries, {
            durationThreshold: opts.durationThreshold || 40,
        });
        report = bindReporter(onReport, metric, INPThresholds, opts.reportAllChanges);
        if (po) {
            po.observe({ type: 'first-input', buffered: true });
            onHidden(function () {
                handleEntries(po.takeRecords());
                if (metric.value < 0 && getInteractionCountForNavigation() > 0) {
                    metric.value = 0;
                    metric.entries = [];
                }
                report(true);
            });
            onBFCacheRestore(function () {
                longestInteractionList = [];
                prevInteractionCount = getInteractionCount();
                metric = initMetric('INP');
                report = bindReporter(onReport, metric, INPThresholds, opts.reportAllChanges);
            });
        }
    });
};

var LCPThresholds = [2500, 4000];
var reportedMetricIDs = {};
var onLCP = function (onReport, opts) {
    opts = opts || {};
    whenActivated(function () {
        var visibilityWatcher = getVisibilityWatcher();
        var metric = initMetric('LCP');
        var report;
        var handleEntries = function (entries) {
            var lastEntry = entries[entries.length - 1];
            if (lastEntry) {
                if (lastEntry.startTime < visibilityWatcher.firstHiddenTime) {
                    metric.value = Math.max(lastEntry.startTime - getActivationStart(), 0);
                    metric.entries = [lastEntry];
                    report();
                }
            }
        };
        var po = observe('largest-contentful-paint', handleEntries);
        if (po) {
            report = bindReporter(onReport, metric, LCPThresholds, opts.reportAllChanges);
            var stopListening_1 = runOnce(function () {
                if (!reportedMetricIDs[metric.id]) {
                    handleEntries(po.takeRecords());
                    po.disconnect();
                    reportedMetricIDs[metric.id] = true;
                    report(true);
                }
            });
            ['keydown', 'click'].forEach(function (type) {
                addEventListener(type, stopListening_1, true);
            });
            onHidden(stopListening_1);
            onBFCacheRestore(function (event) {
                metric = initMetric('LCP');
                report = bindReporter(onReport, metric, LCPThresholds, opts.reportAllChanges);
                doubleRAF(function () {
                    metric.value = performance.now() - event.timeStamp;
                    reportedMetricIDs[metric.id] = true;
                    report(true);
                });
            });
        }
    });
};

var TTFBThresholds = [800, 1800];
var whenReady = function (callback) {
    if (document.prerendering) {
        whenActivated(function () { return whenReady(callback); });
    }
    else if (document.readyState !== 'complete') {
        addEventListener('load', function () { return whenReady(callback); }, true);
    }
    else {
        setTimeout(callback, 0);
    }
};
var onTTFB = function (onReport, opts) {
    opts = opts || {};
    var metric = initMetric('TTFB');
    var report = bindReporter(onReport, metric, TTFBThresholds, opts.reportAllChanges);
    whenReady(function () {
        var navEntry = getNavigationEntry();
        if (navEntry) {
            var responseStart = navEntry.responseStart;
            if (responseStart <= 0 || responseStart > performance.now())
                return;
            metric.value = Math.max(responseStart - getActivationStart(), 0);
            metric.entries = [navEntry];
            report(true);
            onBFCacheRestore(function () {
                metric = initMetric('TTFB', 0);
                report = bindReporter(onReport, metric, TTFBThresholds, opts.reportAllChanges);
                report(true);
            });
        }
    });
};

var initPerformanceObserver = function (url, authInfo) {
    var sendToAnalytics = createApiReporter(url, {
        beforeSend: function (result) {
            return {
                authInfo: authInfo,
                data: __assign(__assign({}, result), getDeviceInfo())
            };
        }
    });
    onLCP(sendToAnalytics);
    onFID(sendToAnalytics);
    onCLS(sendToAnalytics);
    onTTFB(sendToAnalytics);
    onFCP(sendToAnalytics);
    onINP(sendToAnalytics);
};
function createApiReporter(url, opts) {
    if (opts === void 0) { opts = {}; }
    var isSent = false;
    var isCalled = false;
    var result = (__assign({ id: generateUniqueId() }, opts.initial));
    var sendValues = function () {
        if (isSent)
            return;
        if (!isCalled)
            return;
        result.duration = now();
        if (opts.beforeSend) {
            var newResult = opts.beforeSend(result);
            if (newResult)
                result = newResult;
        }
        isSent = true;
        if (opts.onSend) {
            opts.onSend(url, result);
        }
        else {
            if (typeof navigator === 'undefined')
                return;
            if (navigator.sendBeacon) {
                return navigator.sendBeacon(url, JSON.stringify(result));
            }
            var client = new XMLHttpRequest();
            client.open('POST', url, false);
            client.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
            client.send(JSON.stringify(result));
        }
    };
    var mapMetric = opts.mapMetric ||
        function (metric) {
            var _a;
            var isWebVital = ['FCP', 'TTFB', 'LCP', 'CLS', 'FID'].indexOf(metric.name) !== -1;
            return _a = {}, _a[metric.name] = isWebVital ? round(metric.value, metric.name === 'CLS' ? 4 : 0) : metric.value, _a;
        };
    var report = function (metric) {
        if (!isCalled)
            isCalled = true;
        result = __assign(__assign({}, result), mapMetric(metric, result));
    };
    setTimeout(function () {
        var supportedEntryTypes = (PerformanceObserver && PerformanceObserver.supportedEntryTypes) || [];
        var isLatestVisibilityChangeSupported = supportedEntryTypes.indexOf('layout-shift') !== -1;
        if (isLatestVisibilityChangeSupported) {
            var onVisibilityChange_1 = function () {
                if (document.visibilityState === 'hidden') {
                    sendValues();
                    removeEventListener('visibilitychange', onVisibilityChange_1, true);
                }
            };
            addEventListener('visibilitychange', onVisibilityChange_1, true);
        }
        else {
            addEventListener('pagehide', sendValues, { capture: true, once: true });
        }
    });
    return report;
}
function getDeviceInfo() {
    var nav = (typeof navigator ===
        'undefined'
        ? null
        : navigator);
    return {
        url: location ? location.href : null,
        referrer: document ? document.referrer : null,
        memory: nav ? nav.deviceMemory : undefined,
        cpus: nav ? nav.hardwareConcurrency : undefined
    };
}
function now() {
    var perf = typeof performance === 'undefined' ? null : performance;
    return perf && perf.now ? round(perf.now()) : null;
}
function round(val, precision) {
    if (precision === void 0) { precision = 0; }
    return +(Math.round(Number("".concat(val, "e+").concat(precision))) + "e-".concat(precision));
}
function generateUniqueId() {
    return "v1-".concat(Date.now(), "-").concat(Math.floor(Math.random() * (9e12 - 1)) + 1e12);
}

var BrowserClient = (function (_super) {
    __extends(BrowserClient, _super);
    function BrowserClient(options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        var _a;
        _this = _super.call(this, options) || this;
        _this.options = new BrowserOptions(options);
        _this.transport = new BrowserTransport(options);
        _this.breadcrumb = new Breadcrumb(options);
        ((_a = _this.options) === null || _a === void 0 ? void 0 : _a.webPerformance) && initPerformanceObserver(options === null || options === void 0 ? void 0 : options.dsn, _this.transport.getAuthInfo());
        return _this;
    }
    BrowserClient.prototype.isPluginEnable = function (name) {
        var silentField = "".concat(Silent).concat(firstStrtoUppercase(name));
        return !this.options[silentField];
    };
    BrowserClient.prototype.log = function (data) {
        var _a = data.message, message = _a === void 0 ? MitoLogEmptyMsg : _a, _b = data.tag, tag = _b === void 0 ? MitoLogEmptyTag : _b, _c = data.level, level = _c === void 0 ? Severity.Critical : _c, _d = data.ex, ex = _d === void 0 ? '' : _d;
        var errorInfo = {};
        if (isError(ex)) {
            errorInfo = extractErrorStack(ex, level);
        }
        else {
            errorInfo = ex;
        }
        var error = __assign({ type: "LOG", level: level, message: unknownToString(message), name: MitoLog, customTag: unknownToString(tag), time: getTimestamp(), url: getLocationHref() }, errorInfo);
        var breadcrumbStack = this.breadcrumb.push({
            type: "Customer",
            category: getBreadcrumbCategoryInBrowser("Customer"),
            data: message,
            level: Severity.fromString(level.toString())
        });
        this.transport.send(error, breadcrumbStack);
    };
    BrowserClient.prototype.login = function (userId) {
        this.transport.userId = userId;
    };
    BrowserClient.prototype.ping = function (data) {
        var _a = data.message, message = _a === void 0 ? MitoLogEmptyMsg : _a, _b = data.tag, tag = _b === void 0 ? MitoLogEmptyTag : _b, _c = data.level, level = _c === void 0 ? Severity.Critical : _c, _d = data.ex, ex = _d === void 0 ? '' : _d;
        var errorInfo = {};
        if (isError(ex)) {
            errorInfo = extractErrorStack(ex, level);
        }
        var error = __assign({ type: "LOG", level: level, message: unknownToString(message), name: MitoLog, customTag: unknownToString(tag), time: getTimestamp(), url: getLocationHref() }, errorInfo);
        var breadcrumbStack = this.breadcrumb.push({
            type: "Customer",
            category: getBreadcrumbCategoryInBrowser("Customer"),
            data: message,
            level: Severity.fromString(level.toString())
        });
        this.transport.ping(error, breadcrumbStack);
    };
    BrowserClient.prototype.trackSend = function (trackData) {
        this.transport.send(__assign({ isTrack: true }, trackData), this.breadcrumb.getStack());
    };
    return BrowserClient;
}(BaseClient));

function addBreadcrumbInBrowser(data, type, level, params) {
    if (level === void 0) { level = Severity.Info; }
    if (params === void 0) { params = {}; }
    return this.breadcrumb.push(__assign({ type: type, data: data, category: getBreadcrumbCategoryInBrowser(type), level: level }, params));
}
function getQueryStringArgs(url, opt) {
    var _a = opt || {}, _b = _a.decode, decode = _b === void 0 ? true : _b, _c = _a.multiple, multiple = _c === void 0 ? false : _c;
    var args = {};
    if (!(typeof url === 'string' && url.includes('?')))
        return args;
    var arr = url.split('?');
    var qs = arr.length === 2 ? arr[1] : '';
    if (!(typeof qs === 'string' && qs.length))
        return args;
    var items = qs.split('&');
    for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
        var meta = items_1[_i];
        if (!(typeof meta === 'string' && meta.includes('=')))
            continue;
        var item = meta.split('=');
        var key = decode ? decodeURIComponent(item[0]) : item[0];
        var value = decode ? decodeURIComponent(item[1]) : item[1];
        if (Object.prototype.hasOwnProperty.call(args, key) && multiple) {
            var temp = args[key];
            args[key] = Array.isArray(temp) ? __spreadArray(__spreadArray([], temp, true), [value], false) : [temp, value];
        }
        else {
            args[key] = value;
        }
    }
    return args;
}

var xhrPlugin = {
    name: "xhr",
    monitor: function (notify) {
        monitorXhr.call(this, notify);
    },
    transform: function (collectedData) {
        return httpTransform(collectedData);
    },
    consumer: function (transformedData) {
        httpTransformedDataConsumer.call(this, transformedData);
    }
};
function monitorXhr(notify) {
    var _a = this, options = _a.options, transport = _a.transport;
    if (!('XMLHttpRequest' in _global)) {
        return;
    }
    var originalXhrProto = XMLHttpRequest.prototype;
    replaceOld(originalXhrProto, 'open', function (originalOpen) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            this.httpCollect = {
                request: {
                    httpType: "xhr",
                    method: variableTypeDetection.isString(args[0]) ? args[0].toUpperCase() : args[0],
                    url: args[1]
                },
                response: {},
                time: getTimestamp()
            };
            originalOpen.apply(this, args);
        };
    });
    replaceOld(originalXhrProto, 'send', function (originalSend) {
        return function () {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var request = this.httpCollect.request;
            var method = request.method, url = request.url;
            options.setTraceId(url, function (headerFieldName, traceId) {
                request.traceId = traceId;
                _this.setRequestHeader(headerFieldName, traceId);
            });
            options.beforeAppAjaxSend && options.beforeAppAjaxSend({ method: method, url: url }, this);
            on(this, 'loadend', function () {
                var _a;
                var isBlock = transport.isSelfDsn(url) || options.isFilterHttpUrl(url);
                if (isBlock)
                    return;
                var _b = this, responseType = _b.responseType, response = _b.response, status = _b.status;
                request.data = args[0];
                var eTime = getTimestamp();
                if (options.swTraceId) {
                    this.httpCollect.sw = (_a = getQueryStringArgs(url)) === null || _a === void 0 ? void 0 : _a.sw;
                    var sw8TraceId = this.getResponseHeader("sw-traceId");
                    if (sw8TraceId) {
                        this.httpCollect.sw_traceId = sw8TraceId.split(',')[0];
                    }
                }
                if (['', 'json', 'text'].indexOf(responseType) !== -1) {
                    this.httpCollect.response.data = typeof response === 'object' ? JSON.stringify(response) : response;
                }
                this.httpCollect.response.status = status;
                this.httpCollect.elapsedTime = eTime - this.httpCollect.time;
                notify("xhr", this.httpCollect);
            });
            originalSend.apply(this, args);
        };
    });
}
function httpTransform(httpCollectedData) {
    var message = '';
    var _a = httpCollectedData.request, httpType = _a.httpType, method = _a.method, url = _a.url, status = httpCollectedData.response.status, elapsedTime = httpCollectedData.elapsedTime;
    var name = "".concat(httpType, "--").concat(method);
    if (status === 0) {
        message =
            elapsedTime <= globalVar.crossOriginThreshold ? 'http请求失败，失败原因：跨域限制或域名不存在' : 'http请求失败，失败原因：超时';
    }
    else {
        message = fromHttpStatus(status);
    }
    message = message === "ok" ? message : "".concat(message, " ").concat(getRealPath(url));
    return __assign(__assign({}, httpCollectedData), { type: "HTTP", url: getLocationHref(), level: Severity.Low, message: message, name: name });
}
function httpTransformedDataConsumer(transformedData) {
    var type = transformedData.request.httpType === "fetch" ? "Fetch" : "Xhr";
    var status = transformedData.response.status, time = transformedData.time;
    console.log('transformedData: ', transformedData);
    var isError = status === 0 || status === 400 || status > 401;
    addBreadcrumbInBrowser.call(this, transformedData, type, Severity.Info, { time: time });
    if (isError) {
        var breadcrumStack = this.breadcrumb.push({
            type: type,
            category: "exception",
            data: transformedData,
            level: Severity.Error,
            time: time
        });
        this.transport.send(transformedData, breadcrumStack);
    }
}

var fetchPlugin = {
    name: "fetch",
    monitor: function (notify) {
        monitorFetch.call(this, notify);
    },
    transform: function (collectedData) {
        return httpTransform(collectedData);
    },
    consumer: function (transformedData) {
        httpTransformedDataConsumer.call(this, transformedData);
    }
};
function monitorFetch(notify) {
    var _a = this, options = _a.options, transport = _a.transport;
    if (!('fetch' in _global)) {
        return;
    }
    replaceOld(_global, "fetch", function (originalFetch) {
        return function (url, config) {
            if (config === void 0) { config = {}; }
            var sTime = getTimestamp();
            var method = (config && config.method) || 'GET';
            var httpCollect = {
                request: {
                    httpType: "fetch",
                    url: url,
                    method: method,
                    data: config && config.body
                },
                time: sTime,
                response: {}
            };
            var headers = new Headers(config.headers || {});
            Object.assign(headers, {
                setRequestHeader: headers.set
            });
            options.setTraceId(url, function (headerFieldName, traceId) {
                httpCollect.request.traceId = traceId;
                headers.set(headerFieldName, traceId);
            });
            options.beforeAppAjaxSend && options.beforeAppAjaxSend({ method: method, url: url }, headers);
            config = __assign(__assign({}, config), { headers: headers });
            var isBlock = transport.isSelfDsn(url) || options.isFilterHttpUrl(url);
            return originalFetch.apply(_global, [url, config]).then(function (res) {
                var resClone = res.clone();
                var eTime = getTimestamp();
                httpCollect.elapsedTime = eTime - sTime;
                httpCollect.response.status = resClone.status;
                if (options.swTraceId) {
                    httpCollect.sw = getQueryStringArgs(url).sw;
                    var sw8TraceId = resClone.headers.get("sw-traceId");
                    if (sw8TraceId) {
                        httpCollect.sw_traceId = sw8TraceId.split(',')[0];
                    }
                }
                resClone.text().then(function (data) {
                    if (isBlock)
                        return;
                    httpCollect.response.data = data;
                    notify("fetch", httpCollect);
                });
                return res;
            }, function (err) {
                if (isBlock)
                    return;
                var eTime = getTimestamp();
                httpCollect.elapsedTime = eTime - sTime;
                httpCollect.response.status = 0;
                notify("fetch", httpCollect);
                throw err;
            });
        };
    });
}

var domPlugin = {
    name: "dom",
    monitor: function (notify) {
        if (!('document' in _global))
            return;
        var clickThrottle = throttle(notify, this.options.throttleDelayTime);
        on(_global.document, 'click', function () {
            clickThrottle("dom", {
                category: 'click',
                data: this
            });
        }, true);
    },
    transform: function (collectedData) {
        var htmlString = htmlElementAsString(collectedData.data.activeElement);
        return htmlString;
    },
    consumer: function (transformedData) {
        if (transformedData) {
            addBreadcrumbInBrowser.call(this, transformedData, "UI.Click");
        }
    }
};

var errorPlugin = {
    name: "error",
    monitor: function (notify) {
        on(_global, 'error', function (e) {
            notify("error", e);
        }, true);
    },
    transform: function (errorEvent) {
        var target = errorEvent.target;
        if (target.localName) {
            return resourceTransform(errorEvent.target);
        }
        return codeErrorTransform(errorEvent);
    },
    consumer: function (transformedData) {
        var type = transformedData.type === "RESOURCE" ? "Resource" : "Code Error";
        var breadcrumbStack = addBreadcrumbInBrowser.call(this, transformedData, type, Severity.Error);
        this.transport.send(transformedData, breadcrumbStack);
    }
};
var resourceMap = {
    img: '图片',
    script: 'JS脚本'
};
function resourceTransform(target) {
    return {
        type: "RESOURCE",
        url: getLocationHref(),
        message: '资源地址: ' + (interceptStr(target.src, 120) || interceptStr(target.href, 120)),
        level: Severity.Low,
        time: getTimestamp(),
        name: "".concat(resourceMap[target.localName] || target.localName, "\u52A0\u8F7D\u5931\u8D25")
    };
}
function codeErrorTransform(errorEvent) {
    var message = errorEvent.message, filename = errorEvent.filename, lineno = errorEvent.lineno, colno = errorEvent.colno, error = errorEvent.error;
    var result;
    if (error && isError(error)) {
        result = extractErrorStack(error, Severity.Normal);
    }
    result || (result = handleNotErrorInstance(message, filename, lineno, colno));
    result.type = "JAVASCRIPT";
    return result;
}
function handleNotErrorInstance(message, filename, lineno, colno) {
    var name = "UNKNOWN";
    var url = filename || getLocationHref();
    var msg = message;
    var matches = message.match(ERROR_TYPE_RE);
    if (matches[1]) {
        name = matches[1];
        msg = matches[2];
    }
    var element = {
        url: url,
        func: "UNKNOWN_FUNCTION",
        args: "UNKNOWN",
        line: lineno,
        col: colno
    };
    return {
        url: url,
        name: name,
        message: msg,
        level: Severity.Normal,
        time: getTimestamp(),
        stack: [element]
    };
}

var hashRoutePlugin = {
    name: "hashchange",
    monitor: function (notify) {
        if (!isExistProperty(_global, 'onpopstate')) {
            on(_global, "hashchange", function (e) {
                var from = e.oldURL, to = e.newURL;
                notify("hashchange", { from: from, to: to });
            });
        }
    },
    transform: function (collectedData) {
        return routeTransform(collectedData);
    },
    consumer: function (transformedData) {
        routeTransformedConsumer.call(this, transformedData);
    }
};
function routeTransform(collectedData) {
    var from = collectedData.from, to = collectedData.to;
    var parsedFrom = parseUrlToObj(from).relative;
    var parsedTo = parseUrlToObj(to).relative;
    return {
        from: parsedFrom ? parsedFrom : '/',
        to: parsedTo ? parsedTo : '/'
    };
}
function routeTransformedConsumer(transformedData) {
    if (transformedData.from === transformedData.to)
        return;
    addBreadcrumbInBrowser.call(this, transformedData, "Route");
}

var historyRoutePlugin = {
    name: "history",
    monitor: function (notify) {
        var lastHref;
        if (!supportsHistory())
            return;
        var oldOnpopstate = _global.onpopstate;
        _global.onpopstate = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var to = getLocationHref();
            var from = lastHref;
            lastHref = to;
            notify("history", {
                from: from,
                to: to
            });
            oldOnpopstate && oldOnpopstate.apply(this, args);
        };
        function historyReplaceFn(originalHistoryFn) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var url = args.length > 2 ? args[2] : undefined;
                if (url) {
                    var from = lastHref;
                    var to = String(url);
                    lastHref = to;
                    notify("history", {
                        from: from,
                        to: to
                    });
                }
                return originalHistoryFn.apply(this, args);
            };
        }
        replaceOld(_global.history, 'pushState', historyReplaceFn);
        replaceOld(_global.history, 'replaceState', historyReplaceFn);
    },
    transform: function (collectedData) {
        return routeTransform(collectedData);
    },
    consumer: function (transformedData) {
        routeTransformedConsumer.call(this, transformedData);
    }
};

var consolePlugin = {
    name: "console",
    monitor: function (notify) {
        if (!('console' in _global)) {
            return;
        }
        var logType = ['log', 'debug', 'info', 'warn', 'error', 'assert'];
        logType.forEach(function (level) {
            if (!(level in _global.console))
                return;
            replaceOld(_global.console, level, function (originalConsole) {
                return function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    if (originalConsole) {
                        notify("console", { args: args, level: level });
                        originalConsole.apply(_global.console, args);
                    }
                };
            });
        });
    },
    transform: function (collectedData) {
        return collectedData;
    },
    consumer: function (transformedData) {
        if (globalVar.isLogAddBreadcrumb) {
            addBreadcrumbInBrowser.call(this, transformedData, "Console", Severity.fromString(transformedData.level));
        }
    }
};

var name = "unhandledrejection";
var unhandlerejectionPlugin = {
    name: name,
    monitor: function (notify) {
        on(_global, name, function (ev) {
            notify(name, ev);
        });
    },
    transform: function (collectedData) {
        var data = {
            type: "PROMISE",
            message: unknownToString(collectedData.reason),
            url: getLocationHref(),
            name: collectedData.type,
            time: getTimestamp(),
            level: Severity.Low
        };
        if (isError(collectedData.reason)) {
            data = __assign(__assign({}, data), extractErrorStack(collectedData.reason, Severity.Low));
        }
        return data;
    },
    consumer: function (transformedData) {
        var breadcrumbStack = addBreadcrumbInBrowser.call(this, transformedData, "Unhandledrejection", Severity.Error);
        this.transport.send(transformedData, breadcrumbStack);
    }
};

function createBrowserInstance(options, plugins) {
    if (options === void 0) { options = {}; }
    if (plugins === void 0) { plugins = []; }
    var browserClient = new BrowserClient(options);
    var browserPlugins = [
        fetchPlugin,
        xhrPlugin,
        domPlugin,
        errorPlugin,
        hashRoutePlugin,
        historyRoutePlugin,
        consolePlugin,
        unhandlerejectionPlugin
    ];
    browserClient.use(__spreadArray(__spreadArray([], browserPlugins, true), plugins, true));
    return browserClient;
}
var init = createBrowserInstance;

export { BrowserClient, HltnAppNameType, HltnBizType, HltnSubjectType, createBrowserInstance, init, initPerformanceObserver };
/* follow me on Gitlab! @tangjunkai */
//# sourceMappingURL=browser.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@hltn/mitojs-browser/dist/browser.esm.js
// module id = 8vZi
// module chunks = 7